import { render, staticRenderFns } from "./FeedBackEvent.vue?vue&type=template&id=b812dac4&scoped=true"
import script from "./FeedBackEvent.vue?vue&type=script&lang=js"
export * from "./FeedBackEvent.vue?vue&type=script&lang=js"
import style0 from "./FeedBackEvent.vue?vue&type=style&index=0&id=b812dac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b812dac4",
  null
  
)

export default component.exports